import { Component } from "@angular/core";
import { MenuItem } from "primeng/api";
import { SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrl: "./pages.component.css",
})
export class PagesComponent {
  items: MenuItem[] | undefined;
  textoSeguro: SafeHtml = "";

  constructor() {
    this.initLigas();
  }

  initLigas() {
    this.items = [];
  }
}
